import Link from 'next/link';
import React from 'react';
import MWSVG from './common/svg';
type Props = {
    data: string;
    path?: string;
    svgId?: string;
    onclick: any;
    datadescription?: string;
    className?: string;
};

const MenuLink: React.FC<Props> = ({ svgId, data, path, datadescription = '', onclick, className = '' }) => {
    return (
        <Link
            href={`${path}`}
            onClick={onclick}
            className={`menulink py-3 px-5 lg:py-0 !leading-[26px] !lg:leading-[25px] lg:px-0 flex items-start gap-2 hover:text-blue transition-all ${className}`}
        >
            {/* <MWSVG id={svgId} /> */}
            {svgId && <MWSVG id={svgId} />}
            <div>
                {data}
                {datadescription && <p className="text-base mb-0 fw-400">{datadescription}</p>}
            </div>
        </Link>
    );
};

export default MenuLink;
